import { Stack, Typography } from "@mui/material";
import ButtonWithDynamicLink from "./ButtonWithDynamicLink";

const ValueChainData = {
  title: "سامانه زنجیره ارزش آبزیان",
  description:
    "زنجیره ارزش در حوزه پرورش آبزیان، مفهومی است که برای تحلیل فرآیندها و ارزش آفرینی در صنعت پرورش آبزیان از تولید تا عرضه، استفاده می شود.",
  enterPanelBtn: "ورود به پنل کاربر",
  enterPanelDesc:
    "زنجیره ارزش در حوزه پرورش آبزیان، مفهومی است که برای تحلیل فرآیندها و ارزش آفرینی در صنعت پرورش آبزیان از تولید تا عرضه، استفاده می شود.",
};

const ValueChain = ({ newTheme }) => {
  const titleColor = "#BCBBBE";
  return (
    <Stack
      sx={{
        maxWidth: 900,
        mx: "auto",
        width: "100%",
        flexDirection: {
          xs: "column-reverse",
          md: "row",
        },
        m: { xs: 0, lg: 6 },
        my: { xs: 3 },
        gap: { xs: 2, lg: 2 },
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack spacing={2} sx={{ width: "400px" }} justifyContent="center" px={2}>
        <Typography variant="subtitle1" color={titleColor}>
          {ValueChainData.title}
        </Typography>

        <ButtonWithDynamicLink sx={{ width: "300px" }} newTheme={newTheme}>
          {ValueChainData.enterPanelBtn}
        </ButtonWithDynamicLink>
      </Stack>

      <Stack spacing={{ xs: 0, lg: 5 }} justifyContent="center" maxWidth={700} >
        <Stack justifyContent={"center"} alignItems={"center"}>
          <img src="/static/images/AVC_Group.png" alt={ValueChainData.title} style={{maxWidth:400}}/>
        </Stack>
        <Typography variant="subtitle1" color="text.secondary" p={3}>
          {ValueChainData.description}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default ValueChain;
